import ButtonV2 from 'components/common/ButtonV2';
import EditUploadWrapper from 'components/EditUploadWrapper';
import FormikDatePicker from 'components/Fields/FormikDatePicker';
import S3FileUploadField from 'components/S3FileUploadField';
import FormikInputField from 'components/Fields/FormikInputField';
import { PAYMENT_METHODS } from 'pages/Orders/constant';

import { Field } from 'formik';
import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { toast } from 'react-toastify';

const PaymentForm = ({
  onUpdatePayment,
  isEdit,
  values,
  setFieldValue,
  setShowForm,
  onCreatePayment,
  type = 'buyer',
}) => {
  const [saveButtonLoading, setSaveButtonLoading] = React.useState(false);


  const isPaymentInfoValid = (paymentInfo) => {
    if (!paymentInfo) return false; // Handle undefined/null
    const fieldsToCheck = ['utrnumber', 'paidDate', 'paidAmount'];
    if (type === 'seller') {
      fieldsToCheck.push('paymentMethod');
    } // Fields to check
    return fieldsToCheck.every((field) => {
      const value = paymentInfo[field];
      // Check if value exists (not empty string, null, or undefined)
      return value !== '' && value !== null && value !== undefined;
    });
  };

  const hasReceipt = (proofUrl) => {
    if (Array.isArray(proofUrl)) {
      return proofUrl.some((url) =>
        typeof url === 'string' ? url.trim().length > 0 : Boolean(url),
      );
    }

    return typeof proofUrl === 'string'
      ? proofUrl.trim().length > 0
      : Boolean(proofUrl);
  };

  const onClickSave = async () => {
    const paymentInfo = values?.paymentDetails?.[type];
    if (!hasReceipt(paymentInfo?.proofUrl)) {
      toast.error('Please upload the payment receipt before saving.');
      return;
    }

    const isValid = isPaymentInfoValid(paymentInfo);
    if (!isValid) {
      toast.error('Please fill all the required fields in Payment info.');
      return;
    }

    setSaveButtonLoading(true);
    try {
      if (isEdit) {
        await onUpdatePayment();
      } else {
        await onCreatePayment();
      }
    } catch (error) {
      console.error('Error saving payment:', error);
    } finally {
      setSaveButtonLoading(false);
      setShowForm(false);
      setFieldValue(`paymentDetails.${type}`, {
        utrnumber: '',
        paidDate: null,
        paidAmount: '',
        proofUrl: null,
        paymentMethod: '',
      });
    }
  };

  return (
    <Card style={{ border: 'none' }}>
      <div style={{ height: '6px', backgroundColor: '#F8F8F8' }} />
      <div
        className="order-payment__form-header"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px',
          paddingBottom: 0,
        }}
      >
        <h4
          className="f-16 fw-semibold"
          style={{
            overflow: 'hidden',
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px',
            marginBottom: 0,
            paddingBottom: 0,
          }}
        >
          New Payment Details
        </h4>
        <div style={{ textAlign: 'right' }}>
          <ButtonV2
            color="secondary"
            type="button"
            outline
            className="py-1 rounded-0 f-14 ms-2 border-radius-4"
            onClick={() => {
              setFieldValue('paymentDetails', {});
              setShowForm(false);
            }}
          >
            Discard
          </ButtonV2>
          <ButtonV2
            color="primary"
            key="update-charges"
            size="sm"
            style={{
              marginLeft: '10px',
            }}
            className="border-radius-4"
            onClick={onClickSave}
            disabled={saveButtonLoading}
          >
            {saveButtonLoading ? 'Saving...' : 'Save'}
          </ButtonV2>
        </div>
      </div>
      <CardBody>
        <Row>
          <Col sm={6}>
            <Field
              id={`paymentDetails.${type}.utrnumber`}
              name={`paymentDetails.${type}.utrnumber`}
              type="text"
              label="UTR Number"
              component={FormikInputField}
              placeholder="Enter UTR Amount"
              required
            />
          </Col>
          <Col sm={6}>
            <Col sm={6}>
              <Field
                label={
                  <>
                    Paid Date<span style={{ color: 'red' }}>*</span>
                  </>
                }
                name={`paymentDetails.${type}.paidDate`}
                type="text"
                component={FormikDatePicker}
                dateFormat="dd/MM/yyyy"
              />
            </Col>
          </Col>
          <Col sm={6}>
            <Field
              id={`paymentDetails.${type}.paidAmount`}
              name={`paymentDetails.${type}.paidAmount`}
              type="number"
              label="Paid Amount"
              component={FormikInputField}
              placeholder="Enter Paid Amount"
              required
            />
          </Col>

          {type === 'seller' && (
            <Col sm={6}>
              <Field
                id={`paymentDetails.${type}.paymentMethod`}
                name={`paymentDetails.${type}.paymentMethod`}
                type="select"
                label="Payment Method"
                component={FormikInputField}
                required
              >
                <option value="">Select Payment Method</option>
                {PAYMENT_METHODS.map((method) => (
                  <option key={method} value={method}>
                    {method}
                  </option>
                ))}
              </Field>
            </Col>
          )}

          <Col sm={6}>
            {values?.paymentDetails?.[type]?.proofUrl?.length ? (
              <EditUploadWrapper
                name={`paymentDetails.${type}.proofUrl`}
                label="Invoice File"
                fileName={
                  typeof values?.paymentDetails?.[type]?.proofUrl === 'string'
                    ? values?.paymentDetails?.[type]?.proofUrl
                    : values?.paymentDetails?.[type]?.proofUrl[0]
                }
                handleCancel={() => {
                  setFieldValue(`paymentDetails.${type}.proofUrl`, '');
                }}
              />
            ) : (
              <S3FileUploadField
                label="Receipt (image)"
                name={`paymentDetails.${type}.proofUrl`}
                pathUrl="images/order_logistics/vehicle_number"
                required
                accept=".png, .jpg, .jpeg"
                multiple
              />
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default PaymentForm;
